import { initMain } from "./vue/controllers/main";
import { header } from "./vue/controllers/header";

import lazyload from "./features/lazy-load";

lazyload();
initMain([]);
header();
